import React, { useState } from "react";

import classNames from "classnames";
import { FormattedMessage } from "gatsby-plugin-react-intl";
import PropTypes from "prop-types";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/scss";
import "swiper/scss/pagination";

import useMediaQuery from "../../hooks/haiku/useMediaQuery";
import { ReactComponent as IconAnchorLeft18 } from "../../icons/icon/18/a-icon-anchor-left-18.svg";
import { ReactComponent as IconAnchorRight18 } from "../../icons/icon/18/a-icon-anchor-right-18.svg";
import LinkButton from "../button/linkButton";

import "./heroCarousel.scss";

const HeroCarousel = ({
  children,
  eyecatcher = null,
}) => {
  const [swiper, setSwiper] = useState(null);
  const [prevDisabled, setPrevDisabled] = useState(true);

  const isLowerLg = useMediaQuery("(max-width: 991px)", true);

  const childrenArray = React.Children.toArray(children);

  const checkButtons = () => {
    if (swiper) {
      setPrevDisabled(swiper.isBeginning);
    }
  };

  const slideNext = () => {
    if (swiper) {
      if (swiper.isEnd) {
        swiper.slideTo(0);
      } else {
        swiper.slideNext();
      }
    }
  };

  const slidePrev = () => {
    if (swiper) {
      swiper.slidePrev();
    }
  };

  return (
    <div className={classNames("hero-carousel", { "hero-carousel--without-eyecatcher": !eyecatcher })}>
      <div className="container--fullwidth">
        {!isLowerLg && (
          <Container fluid>
            <Row>
              <Col className="d-flex" lg={{ offset: 5, span: 3 }}>
                {!eyecatcher && (Array.isArray(childrenArray)
                  && childrenArray.length > 1) && (
                    <div className="hero-carousel__buttons">
                      <div className="hero-carousel__control-prev">
                        <LinkButton
                          disabled={prevDisabled}
                          variant="normal"
                          onClick={() => {
                            slidePrev();
                          }}
                        >
                          <IconAnchorLeft18 />
                          <FormattedMessage id="hero_carousel.previous" />
                        </LinkButton>
                      </div>
                      <div className="hero-carousel__control-next">
                        <LinkButton
                          variant="normal"
                          onClick={() => {
                            slideNext();
                          }}
                        >
                          <FormattedMessage id="hero_carousel.next" />
                          <IconAnchorRight18 />
                        </LinkButton>
                      </div>
                    </div>
                )}
              </Col>
            </Row>
          </Container>
        )}
        <Swiper
          className="container--fullwidth"
          modules={[Pagination]}
          onSwiper={setSwiper}
          onReachBeginning={checkButtons}
          onReachEnd={checkButtons}
          onSlideChange={checkButtons}
          onAfterInit={checkButtons}
          focusableElements="input, select, option, textarea, video, label"
          mousewheel={{ forceToAxis: true, invert: true }}
          pagination={Array.isArray(childrenArray) && childrenArray.length > 0 && {
            bulletActiveClass: "active",
            clickable: true,
            el: ".swiper-pagination",
            renderBullet: (index, className) => `
                  <div class="pagination__inner ${className}">
                      <div class="d-lg-block d-none typo-small-label">
                          ${childrenArray[index]?.props?.menuTitle}
                      </div>
                  </div>`
            ,
          }}
          slidesPerView={1}
          loop
        >
          {childrenArray.map((child, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <SwiperSlide key={index}>
              {child}
            </SwiperSlide>
          ))}
          <div className="swiper-pagination" />
        </Swiper>
      </div>
      {eyecatcher}
    </div>
  );
};

HeroCarousel.propTypes = {
  children: PropTypes.node.isRequired,
  eyecatcher: PropTypes.oneOfType([PropTypes.object]),
};

export default HeroCarousel;
